module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "flex-items"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box case-manager"
  }), _vm._v(" – My Schedule\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box not-case-manager"
  }), _vm._v(" – Overall Schedule\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box current-time"
  }), _vm._v(" – Current hour\n        ")])])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": true
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "slotTime",
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id)))
        }, [_vm._v(_vm._s(props.item.start_time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.case_manager))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(_vm.getCaseCrew(props.item)))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.case_id))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87f65214","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppointmentsTable.vue
// module id = 1013
// module chunks = 1